import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

export const RemoveFolderItem = createAsyncThunk(
    "Folders/removeFolderitem",
    async ({ token,section,itemId,itemType }, { rejectWithValue }) => {
        try {
            
            const response = await axios.patch(
                `${process.env.REACT_APP_BASE_URL}/${section}/folders/remove-from-folder?${itemType}Id=${itemId}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`, 
                    }, 
                }
            );

            if (response.data.status) {
                return response.data;
            } else {
                return rejectWithValue("Failed to fetch Fodlers");
            }
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Network error"
            );
        }
    }
);


export const getFolderItem = createAsyncThunk(
    "Folders/getFolderitem",
    async ({ token,folderId  }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/folders/open?folderId=${folderId}`,
                
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    
                }
            );

            if (response.data.status) {
                return response.data.response;
            } else {
                return rejectWithValue("Failed to fetch Fodlers");
            }
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Network error"
            );
        }
    }
);



export const updatefolder = createAsyncThunk(
    "Folders/updatefolder",
    async ({ editData, id, token }, { rejectWithValue }) => {
        try {
            console.log(editData)
            const response = await axios.put(
                `${process.env.REACT_APP_BASE_URL}/folders/${id}`,
                editData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );


            if (response.data.status) {
                return response.data;
            } else {
                return rejectWithValue(response.data);
            }
        } catch (error) {
            return rejectWithValue(error.response?.data || "Error updating Folder");
        }
    }
);

export const deleteFolder = createAsyncThunk(
    "Folders/deleteFolder",
    async ({ key, token }, { rejectWithValue }) => {
        try {
            const response = await axios.delete(
                `${process.env.REACT_APP_BASE_URL}/folders/${key}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.data.status) {

                return response.data;
            } else {
                return rejectWithValue("Failed to delete Folder");
            }
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Network error"
            );
        }
    }
);


export const createFolder = createAsyncThunk(
    "Folders/createFolder",
    async ({ formData, token }, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/folders`,
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.status) {
                return response.data;
            } else {
                return rejectWithValue(response.data.message);
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Network error");
        }
    }
);

export const getFolders = createAsyncThunk(
    "Folders/getFolders",
    async ({ token, offset = 1, limit = 100 }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/folders/list`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: { offset, limit },
                }
            );

            if (response.data.status) {
                return response.data.response;
            } else {
                return rejectWithValue("Failed to fetch Fodlers");
            }
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Network error"
            );
        }
    }
);

const folderSlice = createSlice({
    name: "Folder",
    initialState: {
        folderData: [],
        folderItems:[],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getFolders.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getFolders.fulfilled, (state, action) => {
                state.isLoading = false;
                state.folderData = action.payload;
                // toast.success("Folders loaded successfully.");
            })
            .addCase(getFolders.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                // toast.error(action.payload || "Failed to fetch Folders.");
            })
            .addCase(createFolder.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(createFolder.fulfilled, (state, action) => {
                state.isLoading = false;
                // state.screenshotData.unshift(action.payload);
                toast.success(action.payload.response);
            })
            .addCase(createFolder.rejected, (state, action) => {
                state.isLoading = false;
                // state.error = action.payload;
                toast.error(action.payload || "Failed to Create Folder.");
            })
            .addCase(deleteFolder.pending, (state, action) => {
                state.isLoading = true
            })
            .addCase(deleteFolder.fulfilled, (state, action) => {
                state.isLoading = false
                toast(action.payload.response)

            }).addCase(deleteFolder.rejected, (state, action) => {
                state.isLoading = false
                toast(action.payload || "Failed to delete Folder")
            })
            .addCase(updatefolder.pending, (state, action) => {
                state.isLoading = true
            })
            .addCase(updatefolder.fulfilled, (state, action) => {
                state.isLoading = false
                toast(action.payload.response)

            }).addCase(updatefolder.rejected, (state, action) => {
                state.isLoading = false
                toast(action.payload || "Failed to updateFolder")
            })
            .addCase(getFolderItem.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getFolderItem.fulfilled, (state, action) => {
                state.isLoading = false;
                state.folderItems = action.payload;
                // toast.success("Folders loaded successfully.");
            })
            .addCase(getFolderItem.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload || "Failed to fetch Folders.");
            })
            .addCase(RemoveFolderItem.fulfilled,(state,action)=>{
                state.isLoading=false
            
                toast.success(action.payload.response)
            })
            .addCase(RemoveFolderItem.rejected,(state,action)=>{
                state.isLoading=false
                toast.error(action.payload)
            })

    }
})

export default folderSlice.reducer;